import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, Suspense as _Suspense, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "ion-padding-horizontal" }
const _hoisted_2 = { class: "ion-margin-start" }
const _hoisted_3 = {
  key: 2,
  style: {"display":"flex"}
}
const _hoisted_4 = {
  key: 0,
  class: "ion-padding-top"
}
const _hoisted_5 = { class: "ion-padding-top" }
const _hoisted_6 = { class: "ion-padding-top" }
const _hoisted_7 = { class: "ion-padding-top" }
const _hoisted_8 = {
  key: 4,
  class: "ion-padding-start ion-padding-top"
}

import {
  AdminProjectClass,
  AlertInformation,
  CustomElement,
  ErrorCodes,
  LearningSession,
  LearningSessionStatus,
  Outcome,
  OrdinaryClassStudent,
  OrdinaryClassStudentProps,
  OrdinaryClassSummary,
  StudentSummaryProps,
  SubscriptionsManager,
  SubscriptionsManagerMode,
  SuccessCodes,
  TmpList,
  User,
  EnrollmentAvailability,
  GeneralTableCardElements,
  OrderedCardsList,
} from "@/types";
import {
  executeLink,
  getCurrentElement,
  getCustomMessage,
  removeTableIndexedElement,
  setupError,
} from "@/utils";
import { AlertButton, IonAlert, IonModal } from "@ionic/vue";
import { ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";

type AvailableModal =
  | "student_mover"
  | "move_student"
  | "no_courses"
  | "success"
  | "error";


export default /*#__PURE__*/_defineComponent({
  __name: 'OrdinaryClass',
  async setup(__props) {

let __temp: any, __restore: any

const setupModalAndOpen = (
  window: AvailableModal = store.state.event.event,
  message: string = store.state.event.data?.message
) => {
  switch (window) {
    case "student_mover":
      student_mover_data = {
        title: store.state.event.data.title,
        parameters: {
          ...store.state.event.data.parameters,
          ordinary_class: ordinary_class.study_year,
        },
      };
      student_mover_open.value = true;
      break;
    case "move_student":
      alert_information.title = "";
      alert_information.message = getCurrentElement(
        "move_student_confirmation"
      );
      alert_information.buttons = [handled_buttons[0], getCurrentElement("no")];
      alert_open.value = true;
      break;
    case "success":
      alert_information.title = "";
      alert_information.message =
        message ?? getCurrentElement(getCurrentElement("successful_operation"));
      alert_information.buttons = [getCurrentElement("ok")];
      alert_open.value = true;
      break;
    case "error":
      setupError(message);
      alert_open.value = true;
      break;
  }
};
const closeModal = (window: AvailableModal) => {
  switch (window) {
    case "student_mover":
      student_mover_open.value = false;
      break;
    case "move_student":
    case "no_courses":
    case "success":
    case "error":
      alert_open.value = false;
      break;
  }
};
const updateStudents = async (
  do_non_compliants = true,
  do_students = true,
  new_search = true
) => {
  /**
   * @description Update (students, students_table, non_compliant_students_index and non_compliant_table) or (students_table and/or non_compliant_table)
   * @param new_search If true, update search for new students and new non compliant students and update all
   * @param do_students If true and new_search, update students_table
   * @param do_non_compliants If true and new_search, update non_compliant_students_index and non_compliant_table
   * @returns void
   * @async
   */

  if (
    learning_session?.getStatus() == LearningSessionStatus.FUTURE ||
    learning_session?.getStatus() == LearningSessionStatus.UPCOMING
  ) {
    non_compliant_first_row = base_first_row.concat([
      {
        id: "subscribe_to",
        type: "string",
        content: getCurrentElement("subscribe_to"),
      },
    ]);
    non_compliant_column_sizes = ["1", "6", "2", "2", "1"];
  } else {
    non_compliant_first_row = base_first_row;
    non_compliant_column_sizes = ["1", "7", "2", "2"];
  }
  if (new_search) {
    students = await executeLink(
      "/v1/ordinary_classes/" +
        ordinary_class.study_year +
        "/" +
        $route.params.address +
        "/components?school_year=" +
        ordinary_class.school_year +
        "&section=" +
        selected_section.value,
      (response) =>
        response.data.data.map(
          (a: OrdinaryClassStudentProps) => new OrdinaryClassStudent(a)
        ),
      () => []
    );
    if (learning_sessions.length > 0 && students.length > 0) {
      if (new_search && user.type == "admin") {
        non_compliant_students_index = await executeLink(
          "/v1/ordinary_classes/" +
            ordinary_class.study_year +
            "/" +
            $route.params.address +
            "/non_compliant?session_id=" +
            selected_session.value +
            "&section=" +
            selected_section.value,
          (response) =>
            response.data.data.map((a: StudentSummaryProps) =>
              students.findIndex((b) => b.id == a.id)
            ),
          () => []
        ); // Temporary storage of ids to make the search faster later, since students >= non_compliant_students
      }
    }
  }
  if (new_search || do_non_compliants) {
    non_compliant_table.cards[""] = [];
    for (const index in non_compliant_students_index) {
      non_compliant_table.cards[""].push(
        students[non_compliant_students_index[index]].toTableCard(
          parseInt(index) + 1,
          learning_session?.getStatus() == LearningSessionStatus.FUTURE ||
            learning_session?.getStatus() == LearningSessionStatus.UPCOMING
        )
      );
    }
  }
  if (new_search || do_students) {
    students_table.cards[""] = [];
    count = 1;
    for (const i in students) {
      if (non_compliant_students_index.find((a) => "" + a == i) == undefined) {
        students_table.cards[""].push(students[i].toTableCard(count++));
      }
    }
  }
};
const manageEvent = () => {
  switch (store.state.event.event) {
    case "no_courses":
      closeModal("student_mover");
      setupModalAndOpen("error");
      break;
    default:
      setupModalAndOpen();
      break;
  }
};
const yes_handler = async () => {
  let outcome: Outcome, tmp_index: number, tmp_target_index: number;

  switch (store.state.event.event) {
    case "move_student":
      outcome = await subscribeStudent();
      closeModal("move_student");
      switch (outcome.code) {
        case SuccessCodes.GENERIC:
          switch (outcome.subcode) {
            case 1:
              tmp_index = removeTableIndexedElement(
                non_compliant_table,
                store.state.event.data.student_id
              );
              if (tmp_index != -1) {
                count = tmp_index;
                tmp_target_index = -1;
                while (tmp_target_index == -1 && count > 0) {
                  if (
                    non_compliant_students_index[count - 1] !=
                    non_compliant_students_index[count] - 1
                  ) {
                    tmp_target_index =
                      students_table.cards[""].findIndex(
                        (a: any) =>
                          a == students[non_compliant_students_index[count] - 1]
                      ) + 1;
                  } else {
                    count--;
                  }
                }
                if (tmp_target_index == -1) {
                  if (non_compliant_students_index[0] != 0) {
                    tmp_target_index =
                      students_table.cards[""].findIndex(
                        (a: any) =>
                          a == students[non_compliant_students_index[0] - 1]
                      ) + 1;
                  } else {
                    tmp_target_index = 0;
                  }
                }
                students_table.cards[""].splice(
                  tmp_target_index,
                  0,
                  students[non_compliant_students_index[tmp_index]].toTableCard(
                    tmp_target_index + 1
                  )
                );
                non_compliant_students_index.splice(tmp_index, 1);
              } else {
                setupModalAndOpen("error");
              }
              break;
          }
          students_trigger.value++;
          store.state.event.event = "student_mover";
          setTimeout(() => {
            store.state.event.event = "success";
            store.state.event.data = {
              message: outcome.message,
            };
            setupModalAndOpen();
          }, 500);
          break;
        case ErrorCodes.GENERIC:
        case ErrorCodes.BAD_REQUEST:
        case ErrorCodes.ALREADY_EXISTS:
          setTimeout(() => setupModalAndOpen("error", outcome.message), 300);
          break;
      }
      break;
  }
};
const subscribeStudent = async (): Promise<Outcome> => {
  const outcome: Outcome = {
    code: SuccessCodes.GENERIC,
    subcode: 0,
  };

  let enrollment_availability: EnrollmentAvailability;

  if (user.type != "admin") {
    outcome.code = ErrorCodes.UNAUTHORIZED;
    outcome.message = getCurrentElement("unauthorized_operation");
  } else if (
    subscriptions_manager.mode != SubscriptionsManagerMode.SUBSCRIPTION
  ) {
    outcome.code = ErrorCodes.BAD_REQUEST;
  } else if (store.state.event.data.to.final_confirmation != undefined) {
    outcome.code = ErrorCodes.GENERIC;
    outcome.subcode = 0;
    outcome.message = getCurrentElement("class_already_confirmed");
  } else {
    enrollment_availability = subscriptions_manager.checkEnrollmentAvailability(
      store.state.event.data.to.learning_context_id,
      store.state.event.data.to.learning_area_id,
      store.state.event.data.to.course_id
    );
    if (enrollment_availability.course != undefined) {
      if (!enrollment_availability.available_courses) {
        outcome.code = ErrorCodes.GENERIC;
        outcome.subcode = 3;
        outcome.message = getCurrentElement("cannot_move_for_group");
      } else if (!enrollment_availability.available_credits) {
        outcome.code = ErrorCodes.GENERIC;
        outcome.subcode = 4;
        outcome.message = getCurrentElement("cannot_move_for_credits");
      } else {
        await executeLink(
          "/v2/students/" +
            store.state.event.data.student_id +
            "/subscribe?course_id=" +
            store.state.event.data.to.course_id +
            "&session_id=" +
            store.state.event.data.to.session_id +
            "&context_id=" +
            store.state.event.data.to.learning_context_id,
          (response: any) => {
            const pendingDate = new Date(response.data.data ?? "no date");
            const isPending = !isNaN(pendingDate.getTime());
            const enrollment_value = isPending ? pendingDate : true;

            if (!isPending) {
              subscriptions_manager.updateCourseAndLinked(enrollment_value);
              subscriptions_manager.updateCredits(false);
              if (subscriptions_manager.isStudentCompliant()) {
                outcome.subcode = 1;
                outcome.message = getCurrentElement(
                  "student_subscribed_and_compliant"
                );
              } else {
                outcome.message = getCurrentElement("student_subscribed");
              }
            } else {
              outcome.subcode = 2;
              outcome.message = getCurrentElement("pending_student");
            }
          },
          (error) => {
            if (error.response.status == 409) {
              outcome.code = ErrorCodes.ALREADY_EXISTS;
              outcome.subcode = 0;
              if (error.response.data.specified_session) {
                outcome.message = getCurrentElement(
                  "student_already_subscribed"
                );
              } else {
                outcome.message = getCurrentElement(
                  "student_course_already_attended"
                );
              }
            } else {
              outcome.code = ErrorCodes.GENERIC;
              outcome.subcode = 2;
            }
          },
          "post"
        );
      }
    } else {
      outcome.code = ErrorCodes.GENERIC;
      outcome.subcode = 1;
    }
  }

  return outcome;
};

const store = useStore();
const user = User.getLoggedUser() as User;
const sections_use: boolean = store.state.sections_use;
const $route = useRoute();
const $router = useRouter();
const alert_information: AlertInformation = store.state.alert_information;

const students_column_sizes =
  user.type == "admin" ? ["1", "7", "2", "2"] : ["1", "11"];
const base_first_row: CustomElement[] = [
  {
    id: "index",
    type: "string",
    content: "",
  },
  {
    id: "student",
    type: "string",
    content: getCurrentElement("student"),
  },
].concat(
  user.type == "admin"
    ? [
        {
          id: "orientation_credits",
          type: "string",
          content: getCurrentElement("orientation_credits"),
        },
        {
          id: "clil_credits",
          type: "string",
          content: getCurrentElement("clil_credits"),
        },
      ]
    : []
) as CustomElement[];
const students_first_row: CustomElement[] = base_first_row;
const student_mover_open = ref(false);
const students_trigger = ref(0);
const alert_open = ref(false);
const sections: { id: string }[] = [{ id: store.state.default_section }]; //<!-- ? Chiedere a Pietro api per ottenere sezioni da classe
const selected_section = ref(sections[0].id);
const learning_sessions: LearningSession[] = [];
const selected_session = ref(-1);
const handled_buttons: AlertButton[] = [
  {
    text: getCurrentElement("yes"),
    handler: yes_handler,
  },
];
const subscriptions_manager = new SubscriptionsManager(
  SubscriptionsManagerMode.SUBSCRIPTION
); // Not ready, loadParameters will be run with project-class-selector
const ordinary_class = new OrdinaryClassSummary({
  school_year:
    typeof $route.params.school_year == "string"
      ? parseInt($route.params.school_year)
      : NaN,
  address:
    typeof $route.params.address == "string" ? $route.params.address : "",
  study_year:
    typeof $route.params.study_year == "string"
      ? parseInt($route.params.study_year)
      : NaN,
  section: selected_section.value,
});

const students_table: OrderedCardsList<GeneralTableCardElements> = {
  order: [],
  cards: {
    "": [],
  },
};
const non_compliant_table: OrderedCardsList<GeneralTableCardElements> = {
  order: [],
  cards: {
    "": [],
  },
};
let project_class: AdminProjectClass | undefined;
let students: OrdinaryClassStudent[] = [];
let non_compliant_students_index: number[] = [];
let student_mover_data: TmpList;
let non_compliant_first_row: CustomElement[];
let non_compliant_column_sizes: string[];
let learning_session: LearningSession | undefined;
let found = false;
let count: number;
let tmp_learning_session: LearningSession;

if (
  !isNaN(ordinary_class.school_year) &&
  typeof $route.params.address == "string" &&
  !isNaN(ordinary_class.study_year)
) {
  (
  ([__temp,__restore] = _withAsyncContext(() => executeLink(
    "/v1/learning_sessions?school_year=" + ordinary_class.school_year,
    (response) => {
      count = 0;
      while (!found && count < response.data.data.length) {
        tmp_learning_session = new LearningSession(response.data.data[count]);
        learning_sessions.push(tmp_learning_session);
        if (
          tmp_learning_session.getStatus() == LearningSessionStatus.UPCOMING ||
          tmp_learning_session.getStatus() == LearningSessionStatus.FUTURE
        ) {
          found = true;
        }
        count++;
      }
    },
    () => []
  ))),
  await __temp,
  __restore()
);
  if (learning_sessions.length > 0) {
    selected_session.value = learning_sessions[learning_sessions.length - 1].id;
    learning_session = learning_sessions.find(
      (a) => a.id == selected_session.value
    );

    ;(
  ([__temp,__restore] = _withAsyncContext(() => updateStudents(user.type == "admin"))),
  await __temp,
  __restore()
);
    watch(selected_session, async () => {
      learning_session = learning_sessions.find(
        (a) => a.id == selected_session.value
      );
      await updateStudents(user.type == "admin");
      students_trigger.value++;
    });
    watch(selected_section, async () => {
      ordinary_class.section = selected_section.value;
      await updateStudents(user.type == "admin");
      students_trigger.value++;
    });
  }
} else {
  $router.push({ name: "ordinary_classes" }); //<!-- TODO (6): valutare se va bene o mettere solo popup e fare dappertutto
}

return (_ctx: any,_cache: any) => {
  const _component_project_class_selector = _resolveComponent("project-class-selector")!
  const _component_loading_component = _resolveComponent("loading-component")!
  const _component_ionic_element = _resolveComponent("ionic-element")!
  const _component_custom_select = _resolveComponent("custom-select")!
  const _component_ordinary_class_people_adder = _resolveComponent("ordinary-class-people-adder")!
  const _component_ionic_table = _resolveComponent("ionic-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(IonAlert), {
      "is-open": alert_open.value,
      header: _unref(alert_information).title,
      message: _unref(alert_information).message,
      buttons: _unref(alert_information).buttons,
      onDidDismiss: _cache[0] || (_cache[0] = ($event: any) => (closeModal(_unref(store).state.event.event)))
    }, null, 8, ["is-open", "header", "message", "buttons"]),
    _createVNode(_unref(IonModal), {
      id: "student_mover",
      "is-open": student_mover_open.value,
      onDidDismiss: _cache[3] || (_cache[3] = ($event: any) => (closeModal('student_mover')))
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_Suspense, null, {
          default: _withCtx(() => [
            _createVNode(_component_project_class_selector, {
              title: _unref(student_mover_data).title,
              student_id: _unref(student_mover_data).parameters.student_id,
              ordinary_class: _unref(ordinary_class),
              learning_sessions: learning_sessions,
              project_class: _unref(project_class)?.toProjectClassSummary(),
              learning_session: _unref(learning_session),
              section: selected_section.value,
              subscriptions_manager: _unref(subscriptions_manager),
              onClose: _cache[1] || (_cache[1] = ($event: any) => (closeModal('student_mover'))),
              onSignal_event: _cache[2] || (_cache[2] = ($event: any) => (manageEvent()))
            }, null, 8, ["title", "student_id", "ordinary_class", "project_class", "learning_session", "section", "subscriptions_manager"])
          ]),
          fallback: _withCtx(() => [
            _createVNode(_component_loading_component)
          ]),
          _: 1
        }))
      ]),
      _: 1
    }, 8, ["is-open"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_ionic_element, {
        element: 
          _unref(getCustomMessage)(
            'title',
            _unref(ordinary_class).study_year + ' ' + _unref(ordinary_class).address,
            'title',
            undefined,
            {
              label: {
                title_font: true,
              },
            }
          )
        
      }, null, 8, ["element"])
    ]),
    (_unref(sections_use) && sections.length > 0)
      ? (_openBlock(), _createBlock(_component_custom_select, {
          key: 0,
          selected_option: selected_section.value,
          "onUpdate:selected_option": _cache[4] || (_cache[4] = ($event: any) => ((selected_section).value = $event)),
          list: sections,
          label: _unref(getCurrentElement)('section') + ':',
          aria_label: _unref(getCurrentElement)('section'),
          placeholder: _unref(getCurrentElement)('section_choice')
        }, null, 8, ["selected_option", "label", "aria_label", "placeholder"]))
      : _createCommentVNode("", true),
    (_unref(user).type == 'admin' && learning_sessions.length > 0)
      ? (_openBlock(), _createBlock(_component_custom_select, {
          key: 1,
          selected_option: selected_session.value,
          "onUpdate:selected_option": _cache[5] || (_cache[5] = ($event: any) => ((selected_session).value = $event)),
          list: learning_sessions,
          label: _unref(getCurrentElement)('learning_sessions') + ':',
          aria_label: _unref(getCurrentElement)('learning_sessions'),
          placeholder: _unref(getCurrentElement)('learning_sessions_choice'),
          getCompleteName: _unref(LearningSession).toString
        }, null, 8, ["selected_option", "label", "aria_label", "placeholder", "getCompleteName"]))
      : _createCommentVNode("", true),
    (_unref(user).type == 'admin' && learning_sessions.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_ordinary_class_people_adder, {
            school_year: _unref(ordinary_class).school_year,
            study_address: _unref(ordinary_class).address,
            study_year: _unref(ordinary_class).study_year,
            section: selected_section.value,
            onSignal_event: _cache[6] || (_cache[6] = 
          () => {
            setupModalAndOpen();
            updateStudents(true, false, true).then(() => students_trigger.value++);
          }
        )
          }, null, 8, ["school_year", "study_address", "study_year", "section"])
        ]))
      : _createCommentVNode("", true),
    (
        non_compliant_table.cards[''].length > 0 ||
        students_table.cards[''].length > 0
      )
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
          (_unref(user).type == 'admin')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_ionic_element, {
                  element: 
              _unref(getCustomMessage)(
                'title',
                _unref(getCurrentElement)('non_compliant_students'),
                'title',
                undefined,
                {
                  label: {
                    'ion-padding': true,
                  },
                }
              )
            
                }, null, 8, ["element"]),
                (_openBlock(), _createBlock(_Suspense, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      (_openBlock(), _createBlock(_component_ionic_table, {
                        key: students_trigger.value,
                        data: non_compliant_table,
                        first_row: _unref(non_compliant_first_row),
                        sizes: _unref(non_compliant_column_sizes),
                        emptiness_message: 
                    _unref(getCustomMessage)(
                      'emptiness_message',
                      _unref(getCurrentElement)('all_compliant_students'),
                      'string',
                      undefined,
                      {
                        label: {
                          'ion-padding': true,
                        },
                      }
                    )
                  ,
                        onSignal_event: _cache[7] || (_cache[7] = ($event: any) => (setupModalAndOpen())),
                        onExecute_link: _cache[8] || (_cache[8] = ($event: any) => (_unref($router).push(_unref(store).state.request.url)))
                      }, null, 8, ["first_row", "sizes", "emptiness_message"]))
                    ])
                  ]),
                  fallback: _withCtx(() => [
                    _createVNode(_component_loading_component)
                  ]),
                  _: 1
                }))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_ionic_element, {
              element: 
            _unref(getCustomMessage)(
              'title',
              _unref(getCurrentElement)(
                _unref(user).type == 'admin' ? 'compliant_students' : 'students'
              ),
              'title',
              undefined,
              {
                label: {
                  'ion-padding': true,
                },
              }
            )
          
            }, null, 8, ["element"]),
            (_openBlock(), _createBlock(_Suspense, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  (_openBlock(), _createBlock(_component_ionic_table, {
                    key: students_trigger.value,
                    data: students_table,
                    first_row: _unref(students_first_row),
                    sizes: _unref(students_column_sizes),
                    emptiness_message: 
                  _unref(getCustomMessage)(
                    'emptiness_message',
                    _unref(getCurrentElement)('no_compliant_students'),
                    'string',
                    undefined,
                    {
                      label: {
                        'ion-padding': true,
                      },
                    }
                  )
                ,
                    onSignal_event: _cache[9] || (_cache[9] = ($event: any) => (setupModalAndOpen())),
                    onExecute_link: _cache[10] || (_cache[10] = ($event: any) => (_unref($router).push(_unref(store).state.request.url)))
                  }, null, 8, ["first_row", "sizes", "emptiness_message"]))
                ])
              ]),
              fallback: _withCtx(() => [
                _createVNode(_component_loading_component)
              ]),
              _: 1
            }))
          ])
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_ionic_element, {
            element: 
          _unref(getCustomMessage)('no_students', _unref(getCurrentElement)('no_students'))
        
          }, null, 8, ["element"])
        ]))
  ]))
}
}

})